/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>Console table formatting constants</blockquote>
 *
 * @example
 * ```typescript
 * import { CONSOLE_TABLE } from '@shared/reporting';
 *
 * console.log(CONSOLE_TABLE.TITLE_PREFIX); // '📋 '
 * ```
 */
export const CONSOLE_TABLE = {
  TITLE_PREFIX: '📋 ',
  SEPARATOR_CHAR: '─',
  COLUMN_SEPARATOR: ' │ ',
  EVENT_DETAILS_TITLE: 'Event Details',
  EVENT_PROPERTIES_TITLE: 'Event Properties'
} as const;
